import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { AppErrorBoundary } from "@/components/AppErrorBoundary";
import { installAudioUnlock } from "@/utils/alarmAudio";
import { installDayNight } from "@/utils/dayNight";
import { toast } from "sonner";

installAudioUnlock();
// Mode jour (bleu ciel) au lever du soleil, mode nuit au coucher — heure de Dakar
installDayNight();

// Filet de sécurité : un message d'erreur non textuel (liste/objet) ne doit jamais faire planter l'écran
const toText = (m) => {
  if (m == null || typeof m === "string" || typeof m === "number") return m;
  if (Array.isArray(m)) return m.map((x) => (typeof x === "string" ? x : x?.msg || "")).filter(Boolean).join(" · ") || "Informations invalides";
  if (typeof m === "object" && !m.$$typeof) return m.detail || m.msg || m.message || "Une erreur est survenue";
  return m;
};
["error", "warning", "message", "info", "success"].forEach((k) => {
  const orig = toast[k];
  toast[k] = (m, opts) => orig(toText(m), opts);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
);
